import ServiceApi from "../services/service.api";

const baseServiceUrl = `/api/v1/UserWallet`;

const ApiUserWallet = {
  incRiallBalanceForCommisonAgent: (params) => {
    const url = `${baseServiceUrl}/incRiallBalanceForCommisonAgent`;
    return ServiceApi.put(url, params);
  },
  decRiallBalanceForCommisonAgent: (params) => {
    const url = `${baseServiceUrl}/decRiallBalanceForCommisonAgent`;
    return ServiceApi.put(url, params);
  },
  transferWalletBalance: (params) => {
    const url = `${baseServiceUrl}/transferWalletBalance`;
    return ServiceApi.post(url, params);
  },
};
export default ApiUserWallet;


